// Extract upper price from price band like "₹320 - ₹340" => 340
export function getUpperPrice(priceBand: string): number {
  const matches = priceBand.match(/[\d,]+/g);
  if (!matches || matches.length === 0) return 0;
  const last = matches[matches.length - 1].replace(/,/g, "");
  return Number(last) || 0;
}

export function getEstimatedListingPrice(
  priceBand: string,
  gmp: number,
  estimatedListing?: string | number | null,
): number {
  const normalizedGmp = Number(gmp);
  const safeGmp = Number.isFinite(normalizedGmp) ? normalizedGmp : 0;

  const explicitEstimated = Number(String(estimatedListing ?? "").replace(/[^\d.-]/g, ""));
  if (Number.isFinite(explicitEstimated) && explicitEstimated !== 0) {
    return explicitEstimated;
  }

  const upperPrice = getUpperPrice(priceBand);
  if (upperPrice > 0) {
    return upperPrice + safeGmp;
  }

  return safeGmp;
}

// Calculate GMP percentage: (gmp / upperPrice) * 100
export function getGmpPercentage(gmp: number, priceBand: string): string {
  const upper = getUpperPrice(priceBand);
  if (upper === 0) return "0";
  return ((gmp / upper) * 100).toFixed(1);
}
